import { extractHtmlError, fetchWithXsrf, getAntiForgeryToken } from "@siisel/frontend-shared";
import { useState } from "react";
import type { ForgotPasswordFormViewModel } from "../types";

export default function ForgotPasswordFormApp(props: ForgotPasswordFormViewModel) {
  const [userName, setUserName] = useState(props.values.userName);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  async function submit(root: HTMLElement | null) {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    setErrorMessage(null);

    try {
      const formData = new FormData();
      const token = getAntiForgeryToken(root);
      if (token) {
        formData.append("__RequestVerificationToken", token);
      }

      formData.append("UserName", userName);

      const response = await fetchWithXsrf(props.submitUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "text/html"
        },
        body: formData
      });

      if (response.redirected) {
        window.location.href = response.url;
        return;
      }

      const html = await response.text();
      if (!response.ok) {
        throw new Error(html);
      }

      const validationMessage = extractHtmlError(html);
      if (validationMessage) {
        setErrorMessage(validationMessage);
        return;
      }

      window.location.reload();
    } catch (error) {
      const message = error instanceof Error ? error.message : "Akci se nepodarilo provest.";
      setErrorMessage(message.includes("<") ? extractHtmlError(message) || message : message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="forms-app forgot-password-form-app">
      {errorMessage ? <div className="alert alert-danger">{errorMessage}</div> : null}
      <div className="form-group">
        <label htmlFor="forgot-password-user-name">{props.labels.userName}</label>
        <input
          id="forgot-password-user-name"
          className="form-control"
          type="email"
          value={userName}
          disabled={isSubmitting}
          onChange={(event) => {
            setUserName(event.currentTarget.value);
            setErrorMessage(null);
          }}
        />
      </div>
      <button
        type="button"
        className="btn btn-block btn-lg btn-primary"
        disabled={isSubmitting}
        onClick={(event) => void submit(event.currentTarget.closest(".forms-app"))}
      >
        {isSubmitting ? `${props.submitText}...` : props.submitText}
      </button>
    </div>
  );
}
